import { CSSProperties } from 'react';

export function LoadingIndicator({
  testId = 'loading-indicator',
  variant,
}: {
  testId?: string;
  variant?: 'small' | 'invert' | 'small-invert';
}) {
  let sizeClasses = 'w-8 h-8 border-[5px]';
  if (variant === 'small' || variant === 'small-invert') {
    sizeClasses = 'w-4 h-4 m-[2px] border-[3px]';
  }

  const baseBorder =
    variant === 'invert' || variant === 'small-invert'
      ? 'border-white'
      : 'border-mint';

  // Inline style needed for making the bottom border transparent / mint to get the “gap” effect
  const style: CSSProperties = {
    borderBottomColor:
      variant === 'invert' || variant === 'small-invert'
        ? '#0CACA6'
        : 'transparent',
  };

  return (
    <span
      data-testid={testId}
      className={`${sizeClasses} ${baseBorder} box-border inline-block animate-spin rounded-full`}
      style={style}
    />
  );
}
